<template>
    <div class="table-responsive">
        <table :class="tableClass">
            <thead>
                <tr>
                    <th v-if="showCheckbox">
                        <b-form-checkbox v-model="selectAll"
                                         @input="handleSelectAll()">

                        </b-form-checkbox>
                    </th>
                    <!--<th v-if="showIcon">&nbsp;</th>-->
                    <th v-for="n in iconFuncs.length">&nbsp;</th>
                    <th v-for="(col, index) in dataCols"
                        :key="index"
                        @click="handleSortClick(col)"
                        :style="col.showSort ? 'cursor: pointer' : null">
                        {{col.display}} <i v-if="col.showSort" class="fas fa-sort"></i>
                    </th>
                    <th v-if="showActions">Actions</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(item, rowIndex) in dataListItems"
                    :key="'row_' + rowIndex"
                    :class=" selectedItems.includes(rowIndex) ? 'table-primary' : ''"
                    :style="'cursor: pointer'"
                    @click="handleItemClick(rowIndex)"
                    @dblclick="handleDblClick({ index: rowIndex, ...item })">
                    <td v-if="showCheckbox">
                        <div class="custom-control custom-checkbox">
                            <input type="checkbox"
                                   class="custom-control-input"
                                   :key="'check_' + rowIndex"
                                   :ref="'check_' + rowIndex"
                                   :value="rowIndex"
                                   :name="'check_' + rowIndex"
                                   v-model="selectedItems">
                            <label class="custom-control-label"
                                   :for="'check_' + rowIndex">
                            </label>
                        </div>
                    </td>
                    <!--<td v-if="showIcon">
                        <i :class="iconFunc(item)"></i>
                    </td>-->
                    <td v-for="(func, idx) in iconFuncs">
                        <i :class="func(item)"></i>
                    </td>
                    <td v-for="(col, colIndex) in dataCols"
                        :key="'col_' + colIndex">
                        {{getDataValue(item,col)}}
                    </td>
                    <td v-if="showActions">
                        <!--<button v-for="(action, idx) in actions"
                                type="button"
                                @click="handleActionClick({ action: action, item: { index: rowIndex, ...item}})"
                                :class="actionButtonClass(action, idx)"
                                :disabled="action.disabled ? action.disabled(item) : false">
                            <i v-if="action.iconClass" :class="action.iconClass"></i> {{action.text}}
                        </button>
                        <br />-->
                        <div>
                            <b-dropdown size="lg" variant="link" toggle-class="text-decoration-none" no-caret :boundary="'window'">
                                <template v-slot:button-content>
                                    <i class="fa fa-ellipsis-v" aria-hidden="true"></i>
                                    <span class="sr-only">Actions menu</span>
                                </template>
                                <b-dropdown-item v-for="(action, idx) in actions"
                                                 href="javascript:void(0)"
                                                 :disabled="action.disabled ? action.disabled(item) : false"
                                                 @click="handleActionClick({ action: action, item: { index: rowIndex, ...item}})">
                                    <i v-if="action.iconClass" :class="action.iconClass"></i> {{action.text}}
                                </b-dropdown-item>
                            </b-dropdown>
                        </div>

                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
    export default {
        name: 'DataList',
        props: {
            dataCols: Array,
            dataListItems: Array,
            tableClass: String,
            showCheckbox: Boolean,
            //showSort: Boolean,
            //showActions: Boolean,
            actions: Array,
            //showIcon: {
            //    type: Boolean,
            //    required: false,
            //    default: false
            //},
            //iconFunc: {
            //    type: Function,
            //    required: false,
            //    default: () => 'fas fa-question'
            //},
            iconFuncs: {
                type: Array,
                required: false,
                default: () => []
            }
        },
        data: () => {
            return {
                selectAll: false,
                selectedItem: null,
                selectedItems: []
            }
        },
        watch: {
            'dataListItems': function () {
                this.selectAll = false
                this.selectedItem = null
                this.selectedItems = []
            }
        },
        computed: {
            showActions() {
                if (this.actions && Array.isArray(this.actions) && this.actions.length > 0) {
                    return true
                } else {
                    return false
                }
            }
        },
        methods: {
            actionButtonClass(action, idx) {
                let strClass
                if (action.buttonClass) {
                    strClass = action.buttonClass
                } else {
                    strClass = 'btn btn-primary btn-sm'
                }

                if (idx > 0) {
                    strClass = strClass + ' ml-2'
                }

                return strClass
            },
            handleItemClick(item) {
                this.selectedItem = item

                if (!this.showCheckbox) {
                    this.selectedItems = []
                }

                if (!this.selectedItems.includes(item)) {
                    this.selectedItems.push(item)
                } else {
                    let index = this.selectedItems.indexOf(item)
                    this.selectedItems.splice(index, 1)
                }
                let selectedDataListItems = []
                this.selectedItems.forEach(selectedItem => {
                    selectedDataListItems.push(this.dataListItems[selectedItem])
                })
                // HACK!!
                window.setTimeout(() => {
                    this.$emit('sgl-click', selectedDataListItems)
                    this.$emit('change', selectedDataListItems)
                }, 300);

            },
            handleDblClick(payload) {
                this.$emit('dbl-click', payload)
            },
            handleSelectAll() {
                if (this.selectAll) {
                    this.selectedItems = []
                    let total = this.dataListItems.length
                    for (let i = 0; i < total; i++) {
                        this.selectedItems.push(i)
                    }
                } else {
                    this.selectedItems = []
                }
                let selectedDataListItems = []
                this.selectedItems.forEach(selectedItem => {
                    selectedDataListItems.push(this.dataListItems[selectedItem])
                })
                this.$emit('change', selectedDataListItems)
            },
            handleActionClick(payload) {

                this.$emit('action-click', payload)
            },
            handleSortClick(column) {
                if (column.showSort)
                    this.$emit('column-click', column)
            },
            getDataValue(row, col) {
                if (col.customFormatter) {
                    return col.customFormatter(row[col.key])
                } else {
                    return row[col.key]
                }
            }
        }
    }
</script>

<style scoped>
</style>
